import Vue from 'vue';

import Icon from './components/base/Icon.vue';
import Dropdown from './components/base/Dropdown.vue';
import DropdownItem from './components/base/DropdownItem.vue';
import SimpleTabs from './components/base/SimpleTabs.vue';
import SimpleTab from './components/base/SimpleTab.vue';
import FooterNavItem from './components/navigation/FooterNavItem.vue';
import Slider from './components/base/Slider.vue';
import Slide from './components/base/Slide.vue';
import MultiStepForm from './components/form/MultiStepForm.vue';
import AutocompleteInput from './components/form/AutocompleteInput.vue';
import SelectaHeader from './components/navigation/SelectaHeader.vue';
import NavigationItem from './components/navigation/NavigationItem.vue';
import NavigationSubItem from './components/navigation/NavigationSubItem.vue';
import CustomCursor from './components/base/CustomCursor.vue';
import Overview from './components/overview/Overview.vue';
import FilterArticle from './components/overview/FilterArticle.vue';
import Category from './components/overview/Category.vue';
import CategoryArticle from './components/overview/CategoryArticle.vue';
import OverviewItem from './components/overview/OverviewItem.vue';
import Filter from './components/overview/Filter.vue';
import CollapseTransition from '@ivanv/vue-collapse-transition/src/CollapseTransition.vue';
import Tab from './components/base/Tab.vue';
import Tabs from './components/base/Tabs.vue';
import Lightbox from './components/base/Lightbox.vue';
import FormSubmit from './components/form/FormSubmit.vue';
import ServiceForm from './components/form/ServiceForm.vue';
import FormDropdown from './components/form/FormDropdown.vue';
import Popup from './components/base/Popup.vue';
import CheckboxGroup from './components/form/CheckboxGroup.vue';
import SearchResults from './components/search/SearchResults.vue';

Vue.component('icon', Icon);
Vue.component('dropdown', Dropdown);
Vue.component('dropdown-item', DropdownItem);
Vue.component('footer-nav-item', FooterNavItem);
Vue.component('slider', Slider);
Vue.component('slide', Slide);
Vue.component('simple-tabs', SimpleTabs);
Vue.component('simple-tab', SimpleTab);
Vue.component('multi-step-form', MultiStepForm);
Vue.component('autocomplete-input', AutocompleteInput);
Vue.component('selecta-header', SelectaHeader);
Vue.component('navigation-item', NavigationItem);
Vue.component('navigation-sub-item', NavigationSubItem);
Vue.component('custom-cursor', CustomCursor);
Vue.component('slct-overview', Overview);
Vue.component('slct-filter-art', FilterArticle);
Vue.component('slct-filter', Filter);
Vue.component('slct-category-art', CategoryArticle);
Vue.component('slct-item', OverviewItem);
Vue.component('slct-category', Category);
Vue.component('collapse-transition', CollapseTransition);
Vue.component('slct-tab', Tab);
Vue.component('slct-tabs', Tabs);
Vue.component('lightbox', Lightbox);
Vue.component('form-submit', FormSubmit);
Vue.component('service-form', ServiceForm);
Vue.component('form-dropdown', FormDropdown);
Vue.component('popup', Popup);
Vue.component('checkbox-group', CheckboxGroup);
Vue.component('search-results', SearchResults);
